<template>
  <div>
    <div
      v-if="!uiFlags.isFetching && !localMacros.length"
      class="macros_list--empty-state"
    >
      <p class="no-items-error-message">
        {{ $t('MACROS.LIST.404') }}
      </p>
      <router-link :to="addAccountScoping('settings/macros')">
        <woot-button
          variant="smooth"
          icon="add"
          size="tiny"
          class="macros_add-button"
        >
          {{ $t('MACROS.HEADER_BTN_TXT') }}
        </woot-button>
      </router-link>
    </div>
    <woot-loading-state
      v-if="uiFlags.isFetching"
      :message="$t('MACROS.LOADING')"
    />
    <draggable
      v-if="!uiFlags.isFetching && localMacros.length"
      v-model="localMacros"
      animation="200"
      ghost-class="ghost"
      handle=".drag-handle"
      tag="div"
      item-key="id"
      @start="dragging = true"
      @end="onDragEnd"
    >
      <macro-item
        v-for="macro in localMacros"
        :key="macro.id"
        :macro="macro"
        class="drag-handle cursor-grab"
        :conversation-id="conversationId"
      />
    </draggable>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MacroItem from './MacroItem';
import accountMixin from 'dashboard/mixins/account.js';
import Draggable from 'vuedraggable';

export default {
  components: {
    MacroItem,
    Draggable,
  },
  mixins: [accountMixin],
  props: {
    conversationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      dragging: false,
      localMacros: [], // Local copy of macros
    };
  },
  computed: {
    ...mapGetters({
      macros: ['macros/getMacros'],
      uiFlags: 'macros/getUIFlags',
      additionalAttributes: 'getAdditionalAttributes',
      getCurrentUser: 'getCurrentUser',
    }),
    orderedMacros() {
      const savedOrder = this.additionalAttributes?.macros_display_order ?? [];
      const currentMacros = this.macros ?? [];
      if (!savedOrder.length || !currentMacros.length) {
        return currentMacros;
      }

      const orderMap = new Map(savedOrder.map((id, index) => [id, index]));
      return [...currentMacros].sort((a, b) => {
        const aPos = orderMap.get(a.id) ?? Infinity;
        const bPos = orderMap.get(b.id) ?? Infinity;
        return aPos - bPos;
      });
    },
  },
  mounted() {
    this.$store.dispatch('macros/get').then(() => {
      this.initLocalMacros();
    });
  },
  methods: {
    initLocalMacros() {
      this.localMacros = [...this.orderedMacros];
    },
    async onDragEnd() {
      this.dragging = false;
      const orderedIds = this.localMacros.map(({ id }) => id);
      this.$store.dispatch('updateProfile', {
        account_id: +this.$route.params.accountId,
        additional_attributes: {
          macros_display_order: orderedIds,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import '../../../../../dashboard/assets/scss/macros-node';

.ghost {
  opacity: 0.5;
  background-color: var(--n-slate-3);
  &.dark {
    background-color: var(--n-slate-9);
  }
}
.macros-list {
  padding: var(--space-small);
  > div {
    border-bottom: 1px solid var(--s-50);
    padding: var(--space-one) !important;
  }
}
.macros_list--empty-state {
  padding: var(--space-slab);
  p {
    margin: 0;
  }
}
.macros_add-button {
  background: transparent;
  font-size: var(--font-size-mini);
  color: var(--v-400);
  padding: var(--space-smaller);
  margin: var(--space-small) auto 0;
}
::v-deep {
  svg {
    width: var(--space-snug);
    height: var(--space-snug);
  }
  .no-items-error-message {
    min-height: 12rem;
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-normal);
  }
}
</style>
